import styleService from '@nykaa/deals-utils/styles';
import styled from '../../theme';
const { getPaddingStyles, getFontStyles, addAlpha, getBorderStyles, getMarginStyles, } = styleService.utils;
export const FilterChip = styled.div `
  display: inline-flex;
  align-items: center;
  ${({ padding }) => getPaddingStyles(padding)};
  text-transform: capitalize;
  cursor: pointer;
  background-color: ${({ bkg }) => addAlpha(bkg === null || bkg === void 0 ? void 0 : bkg.color, bkg === null || bkg === void 0 ? void 0 : bkg.alpha)};
  ${({ text }) => getFontStyles(text)};
  ${({ border }) => getBorderStyles(border)};
  border-radius: ${({ cornerRadius }) => cornerRadius === null || cornerRadius === void 0 ? void 0 : cornerRadius.web};
  .filter-text {
    display:inline-block;
    white-space: nowrap;
  }
  .tabs-text {
    display:inline-block;
    white-space: nowrap;
  }
`;
export const Wrapper = styled.div `
  overflow-y: hidden;
  height: auto;
  width: 100%;
  scroll-behavior: smooth;
  display: flex;
  white-space: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  column-gap: ${({ gap }) => gap === null || gap === void 0 ? void 0 : gap.web};
  ${({ margin }) => getMarginStyles(margin)};
`;
export const ChipWrapper = styled.div `
  display: block;
  position: relative;
  vertical-align: top;
  :last-of-type { 
    margin-right: ${({ isDesktop }) => (isDesktop ? '3rem' : '1.25rem')};
  }
  :first-of-type {
    margin-left: ${({ isDesktop }) => (isDesktop ? '3rem' : '1.25rem')};
  }
`;
